

define(['squid/index', './directive', 'components/xo-address-components/src/add-address/directive', 'components/xo-address-components/src/address-normalization/route'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-card.addbilling.route', ['squid', 'xo-add-card.addbilling.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddBillingRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddBillingRoute', {

            name: 'addBilling',
            directive: 'xo-add-billing',
            titleContent: 'addBillingAddress.title',

            trackingData: {
                fptiState: 'edit_billing'
            },
            loginRequired: true,
            children: [{
                name: '$AddressNormalizationRoute',
                attributes: {
                    id: 'token',
                    sidebar: 'sidebar',
                    address: 'address',
                    'done-fn': 'uponNormalization'
                }
            }]

        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-card/addbilling/route.js
// module id = ./components/xo-wallet-components/src/add-card/addbilling/route.js
// module chunks = 1